import { useState, } from 'react';
import {
	Box,
	Button,
	Column,
	Icon,
	IconButton as IB,
	Row,
	Slider,
	Text,
	useToast,
} from 'native-base';
import {
	FontAwesome5,
	Ionicons,
} from '@expo/vector-icons';
import {
	PLAYER_SIZE__SMALL,
	PLAYER_SIZE__BIG,
} from '../constants/PlayerSizes';
import {
	RATE__0_25,
	RATE__0_5,
	RATE__0_75,
	RATE__1,
	RATE__1_25,
	RATE__1_5,
	RATE__1_75,
	RATE__2,
	RATE__4,
	RATE__8,
	RATE__16,
} from '../constants/Rates';
import { useDimensions } from '@react-native-community/hooks';
import withRedux from '../OneHat/data/hoc/withRedux';
import testProps from '../OneHat/functions/testProps';
import IconButton from '../OneHat/components/IconButton';
import AltIcon from './Icons/AltIcon';
import LoopIcon from './Icons/LoopIcon';
import RateIcon025 from './Icons/RateIcon-.25x';
import RateIcon05 from './Icons/RateIcon-.5x';
import RateIcon075 from './Icons/RateIcon-.75x';
import RateIcon1 from './Icons/RateIcon-1x';
import RateIcon125 from './Icons/RateIcon-1.25x';
import RateIcon15 from './Icons/RateIcon-1.5x';
import RateIcon175 from './Icons/RateIcon-1.75x';
import RateIcon2 from './Icons/RateIcon-2x';
import MouthIcon from './Icons/MouthIcon';
import PresentationIcon from './Icons/PresentationIcon';
import _ from 'lodash';


function PlayerModal(props) {
	const {
			playerSize,
			playerIsShown,
			showProofs,
			audioIsReady,
			audioIsPlaying,
			audioIsLooping,
			audioIsKaraokeMode,
			audioHasAlt,
			audioIsAlt,
			audioIsScrubbing,
			audioIsAutoAdvance,
			audioIsLyricsMode,
			audioRate,
			audioTime,
			audioDuration,
			audioPercentage,

			actions,
		} = props,
		toast = useToast(),
		[scrubPercentage, setScrubPercentage] = useState(false),
		sliderPercentage = audioIsScrubbing ? scrubPercentage : audioPercentage,
		scrubTime = scrubPercentage / 100 * audioDuration,
		time = (new Date(((audioIsScrubbing ? scrubTime : audioTime) || 0) * 1000).toISOString().substring(14, 19)),
		duration = (new Date((audioDuration || 0) * 1000).toISOString().substring(14, 19)),
		showToast = (message) => {
			toast.show({
				title: message,
				duration: 800,
				isClosable: false,
				variant: 'subtle',
				bottom: 180,
			});
		},
		togglePlayerSize = () => {
			let size;
			if (playerSize === PLAYER_SIZE__BIG) {
				size = PLAYER_SIZE__SMALL;
			} else if (playerSize === PLAYER_SIZE__SMALL) {
				size = PLAYER_SIZE__BIG;
			}
			actions.setPlayerSize(size);
		},
		togglePlayback = () => {
			actions.togglePlayback();
		},
		toggleIsLooping = () => {
			actions.toggleIsLooping();

			const message = audioIsLooping ? 'Looping deactivated' : 'Looping activated';
			showToast(message);
		},
		toggleIsAutoAdvance = () => {
			actions.toggleIsAutoAdvance();
			const message = audioIsAutoAdvance ? 'Auto advance deactivated' : 'Auto advance activated';
			showToast(message);
		},
		toggleIsKaraokeMode = () => {
			actions.toggleIsKaraokeMode();
			const message = !audioIsKaraokeMode ? 'Voices deactivated' : 'Voices activated';
			showToast(message);
		},
		toggleIsAlt = () => {
			actions.toggleIsAlt();
			const message = !audioIsAlt ? 'Alternate song selected' : 'Primary song selected';
			showToast(message);
		},
		toggleRate = () => {
			const rates = [
					// RATE__0_25,
					RATE__0_5,
					// RATE__0_75,
					RATE__1,
					// RATE__1_25,
					RATE__1_5,
					// RATE__1_75,
					RATE__2,
					// RATE__4,
					// RATE__8,
					// RATE__16,
				],
				currentIx = rates.indexOf(audioRate),
				nextRate = (currentIx === rates.length -1) ? rates[0] : rates[currentIx +1]; // advance to next, or go back to beginning
			actions.setRate(nextRate);
		},
		toggleIsLyricsMode = () => {
			actions.toggleIsLyricsMode();
			const message = audioIsLyricsMode ? 'Lyric animation deactivated' : 'Lyric animation activated';
			showToast(message);
		},
		toggleProofs = () => {
			actions.setShowProofs(!showProofs);
		},
		startScrubbing = (value) => {
			setScrubPercentage(value);
			actions.startScrubbing();
		},
		endScrubbing = (value) => {
			actions.endScrubbing(value);
		};
	
	if (!playerIsShown) {
		return null;
	}

	const iconButtonContainerProps = {
			justifyContent: 'center',
			alignItems: 'center',
		},
		iconButtonProps = {
			flex: 1,
			variant: 'ghost',
		},
		iconProps = {
			alignSelf: 'center',
			color: 'primary.800',
			size: 'lg',
			px: 0,
		},
		overlayProps = {
			w: '100%',
			bg: 'trueGray.200',
			p: 1,
			bg: 'primary.300',
		};
	
	let RateIcon;
	switch(audioRate) {
		case RATE__0_25:
			RateIcon = RateIcon025;
			break;
		case RATE__0_5:
			RateIcon = RateIcon05;
			break;
		case RATE__0_75:
			RateIcon = RateIcon075;
			break;
		case RATE__1:
			RateIcon = RateIcon1;
			break;
		case RATE__1_25:
			RateIcon = RateIcon125;
			break;
		case RATE__1_5:
			RateIcon = RateIcon15;
			break;
		case RATE__1_75:
			RateIcon = RateIcon175;
			break;
		case RATE__2:
			RateIcon = RateIcon2;
			break;
	}
	const expandBtn = <IconButton
						{...testProps('expandBtn')}
						{...iconButtonProps}
						icon={<Icon as={FontAwesome5} {...iconProps} name="expand" size="sm" />}
						onPress={togglePlayerSize}
					/>,
		rateBtn = <IconButton
						{...testProps('rateBtn')}
						{...iconButtonProps}
						p={0}
						icon={<RateIcon {...iconProps} size="4xl" />}
						onPress={toggleRate}
					/>,
		bigPlayBtn = <IconButton
						{...testProps('playBtn')}
						{...iconButtonProps}
						icon={<Icon as={FontAwesome5} {...iconProps} left={2} size="4xl" name={audioIsPlaying ? 'pause' : 'play'} />}
						onPress={togglePlayback}
						isDisabled={!audioIsReady}
					/>,
		playBtn = <IconButton
						{...testProps('playBtn')}
						{...iconButtonProps}
						icon={<Icon as={FontAwesome5} {...iconProps} name={audioIsPlaying ? 'pause' : 'play'} />}
						onPress={togglePlayback}
						isDisabled={!audioIsReady}
					/>,
		karaokeBtn = <IconButton
						{...testProps('karaokeBtn')}
						{...iconButtonProps}
						icon={<MouthIcon {...iconProps} color={!audioIsKaraokeMode ? 'primary.800' : 'primary.100'} />}
						onPress={toggleIsKaraokeMode}
					/>,
		lyricsBtn = <IconButton
						{...testProps('lyricsBtn')}
						{...iconButtonProps}
						icon={<PresentationIcon {...iconProps} color={audioIsLyricsMode ? 'primary.800' : 'primary.100'} />}
						onPress={toggleIsLyricsMode}
					/>,
		loopBtn = <IconButton
						{...testProps('loopBtn')}
						{...iconButtonProps}
						icon={<LoopIcon {...iconProps} color={audioIsLooping ? 'primary.800' : 'primary.100'} />}
						onPress={toggleIsLooping}
					/>,
		autoAdvanceBtn = <IconButton
						{...testProps('autoAdvanceBtn')}
						{...iconButtonProps}
						icon={<Icon as={FontAwesome5} {...iconProps} name="share" color={audioIsAutoAdvance ? 'primary.800' : 'primary.100'} />}
						onPress={toggleIsAutoAdvance}
					/>,
		altBtn = <IconButton
						{...testProps('altBtn')}
						{...iconButtonProps}
						icon={<AltIcon {...iconProps} color={audioIsAlt ? 'primary.800' : 'primary.100'} />}
						onPress={toggleIsAlt}
					/>,
		proofsBtn = <IconButton
						{...testProps('proofsBtn')}
						{...iconButtonProps}
						icon={<Icon as={FontAwesome5} {...iconProps} name="book" color="primary.800" />}
						onPress={toggleProofs}
					/>,
		sliderProps = {
			minValue: 0,
			maxValue: 100,
			width: '90%',
			onChange: startScrubbing,
			onChangeEnd: endScrubbing,
			value: sliderPercentage,
		},
		slider = <Slider {...sliderProps}>
						<Slider.Track>
							<Slider.FilledTrack />
						</Slider.Track>
						<Slider.Thumb />
					</Slider>,
		readout = <Text textAlign="center">{time} / {duration}</Text>;

	let elements;
	if (playerSize === PLAYER_SIZE__BIG) {
		overlayProps.h = '180px';
		elements = <Column {...overlayProps}>
						<Row {...iconButtonContainerProps}>
							{expandBtn}
							{rateBtn}
							{bigPlayBtn}
							{loopBtn}
							{autoAdvanceBtn}
						</Row>
						<Row>
							<Column flex={15} justifyContent="center" alignItems="center">
								{slider}
								{readout}
							</Column>
						</Row>
						<Row {...iconButtonContainerProps}>
							{lyricsBtn}
							{proofsBtn}
							{audioHasAlt && altBtn}
							{karaokeBtn}
						</Row>
					</Column>;
	}
	if (playerSize === PLAYER_SIZE__SMALL) {
		overlayProps.h = '60px';
		elements = <Row {...overlayProps}>
						{expandBtn}
						<Column flex={15} justifyContent="center" alignItems="center">
							{slider}
							{readout}
						</Column>
						{playBtn}
					</Row>;
	}
	
	return elements;
}

export default withRedux(PlayerModal, [
	'playerSize',
	'playerIsShown',
	'showProofs',
	'audioIsReady',
	'audioIsPlaying',
	'audioIsLooping',
	'audioIsKaraokeMode',
	'audioHasAlt',
	'audioIsAlt',
	'audioIsDucking',
	'audioIsScrubbing',
	'audioIsAutoAdvance',
	'audioIsLyricsMode',
	'audioRate',
	'audioTime',
	'audioDuration',
	'audioPercentage',
	'audioError',
	'audioQuestion',
	'audioLyrics',
]);